import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  DialogTitle, Box, Button,
} from '@material-ui/core';
import LogOutputSearchComponent from './LogOutputSearchComponent';
import LogOutputChartComponent from './LogOutputChartComponent';
import { executeFileDownload } from '../../actions/LogOutputAction';
import { setInitMessage, setSystemLodingFLg } from '../../actions/CommonAction';
import styles from './LogOutputComponent.module.css';
import MyIcon from '../common/MyIcon';
/**
 * アクセスログ画面コンポーネント
 */
class LogOutputComponent extends Component {
  componentDidMount() {
    // Google Analytics
    window.gtagPageview();
  }

  componentWillUnmount() {
    const { setInitMessageAct } = this.props;
    setInitMessageAct();
  }

  downloadFile = async () => {
    const {
      targetYM,
      targetFunc,
      executeFileDownloadAct,
      setSystemLodingFLgAct,
    } = this.props;

    setSystemLodingFLgAct(true);
    await executeFileDownloadAct(targetYM, targetFunc);
    setSystemLodingFLgAct(false);
  }

  render() {
    return (
      <div className={`${styles.logoutput}`}>
        <div className={`${styles.container}`}>
          <div className={`${styles.accesslog}`}>
            <div className={`${styles.headerfield}`}>
              <Box className={`${styles.tabfield}`}>
                <DialogTitle>利用状況照会</DialogTitle>
              </Box>
              <div className={`${styles.targetbutton}`}>
                <Box className={`${styles.button}`}>
                  <Button
                    variant="contained"
                    color="secondary"
                    startIcon={<MyIcon className="downloadIcon" type="download" />}
                    onClick={this.downloadFile}
                  >
                    CSVダウンロード
                  </Button>
                </Box>
              </div>
            </div>
            <LogOutputSearchComponent />
            <LogOutputChartComponent />
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  (state) => ({
    targetYM: state.logoutput.targetYM,
    targetFunc: state.logoutput.targetFunc,
  }),
  (dispatch) => ({
    setInitMessageAct: () => dispatch(setInitMessage()),
    setSystemLodingFLgAct: (bool) => dispatch(setSystemLodingFLg(bool)),
    executeFileDownloadAct: (str1, str2) => dispatch(executeFileDownload(str1, str2)),
  }),
)(LogOutputComponent);
